

<template functional>
    <footer class="the-footer bg-main-footer pb-24" :class="classes">
      <section class="vx-row justify-between w-full">
        <div class="vx-col w-full lg:w-1/2 pl-24 mt-24">
          <div class="vx-row justify-between">
            <div class="vx-col w-full md:w-1/3 mb-4 md:mb-0">
              <img src="/assets/images/footer/logozx.svg" alt="" class="w-24" />
            </div>
            <ul class="vx-col w-full md:w-1/3 mb-4 md:mb-0">
              <li class="mb-2">
                <router-link to="/about" class="text-white">Tentang ZX</router-link>
              </li>
              <li class="mb-2">
                <router-link to="/sahabat-zx" class="text-white">Sahabat ZX</router-link>
              </li>
              <li class="mb-2">
                <router-link to="/promo" class="text-white">Promo</router-link>
              </li>
              <li class="mb-2">
                <router-link to="/zxcare" class="text-white">ZX Care</router-link>
              </li>
              <li class="mb-2">
                <router-link to="/faq" class="text-white"><strong>Bantuan dan Panduan</strong></router-link>
              </li>
              <li class="mb-2">
                <router-link to="/terms-conditions" class="text-white">Syarat dan Ketentuan</router-link>
              </li>
              <li class="mb-2">
                <router-link to="/privacy-policy" class="text-white">Kebijakan dan Privasi</router-link>
              </li>
            </ul>
            <section class="vx-col w-full md:w-1/3">
              <h5 class="mb-4 text-white"><b>Ikuti Kami</b></h5>
              <div class="flex items-center">
                <a href="https://instagram.com" target="_blank">
                  <img src="/assets/images/footer/ig.svg" alt="" class="w-12 px-2" />
                </a>
                <a href="https://facebook.com" target="_blank">
                  <img src="/assets/images/footer/fb.svg" alt="" class="w-12 px-2" />
                </a>
                <a href="https://www.tiktok.com" target="_blank">
                  <img src="/assets/images/footer/tiktok.svg" alt="" class="w-12 px-2" />
                </a>
                <a href="https://youtube.com" target="_blank">
                  <img src="/assets/images/footer/yt.svg" alt="" class="w-12 px-2" />
                </a>
              </div>
            </section>
          </div>
          <div class="block lg:hidden pt-12">
            <p class="text-white text-center">
              <small>&copy; 2009-2022, PT Inti Smart Solution</small>
            </p>
          </div>
        </div>
        <div class="vx-col hidden lg:block lg:w-1/2">
          <section class="flex justify-center mb-4">
            <!-- 2phone -->
            <img src="/assets/images/footer/2phone.png" id="2phone"  alt="" />   

          </section>
          <div class="flex justify-center mb-4">
            <img src="/assets/images/footer/playstore.png" class="w-1/5 px-2" alt="" />
            <!-- <img src="/assets/images/footer/appstore.png" class="w-1/5 px-2" alt="" /> -->
          </div>
          <p class="text-white copyright text-center">
            <small>&copy; 2009-2022, PT Inti Smart Solution</small>
          </p>
          
        </div>
      </section>
        
    </footer>
</template>
<style>
  .bg-main-footer {
    background-color: #045532;
    background-image: url('/assets/images/footer/bg.svg');
    background-repeat: no-repeat;
    background-size: cover;
  }
  .lazy-load {

  }
</style>
<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
